<template>
  <div class="common-introduce-container">
    <img class="text-img" :src="textImg" />
    <img class="decorator" src="../../assets/imgs/home/video-decorator.jpg" />
    <div class="text">{{text}}</div>
    <div class="img-container">
      <img class="intro" :src="introImg" />
      <img class="intro-bg" src="../../assets/imgs/home/introduce-bg.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonIntroduce',
  props: ['text', 'textImg', 'introImg'],
  data() {
    return {};
  },
};
</script>

<style lang='less' scoped>
.common-introduce-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
  .text-img {
    height: 34px;
  }
  .decorator {
    width: 750px;
    height: 38px;
  }
  .text {
    font-size:30px;
    font-family:Source Han Sans CN;
    font-weight:400;
    color:rgba(2,239,236,1);
    margin: 29px 0 21px;
  }
  .img-container {
    position: relative;
    .intro {
      width: 627px;
      height: 380px;
    }
    .intro-bg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 650px;
      height: 402px;
    }
  }
}
</style>
